import React from 'react';
import { Route } from 'react-router-dom';
import { DashboardShell } from './DashboardShell';
import { FeatureRoute } from '../components/FeatureRoute';
import { TrustFeatureRoute } from '../components/TrustFeatureRoute';
import * as Pages from './lazyPages';

/**
 * All authenticated dashboard pages share one layout route.
 * Navigating between these paths only swaps the <Outlet /> — sidebar/topbar persist.
 */
export const dashboardRouteElements = (
  <Route element={<DashboardShell />}>
    <Route path="/jobseeker-dashboard" element={<Pages.JobseekerDashboard />} />
    <Route path="/referral-dashboard" element={<Pages.ReferralDashboard />} />

    <Route element={<FeatureRoute featureKey="resume-review" redirectTo="/jobseeker-dashboard" />}>
      <Route path="/jobseeker-dashboard/resume-review" element={<Pages.ResumeReview />} />
    </Route>
    <Route path="/jobseeker-dashboard/resume-grader" element={<Pages.ResumeGrader />} />
    <Route element={<FeatureRoute featureKey="culture-call" redirectTo="/jobseeker-dashboard" />}>
      <Route path="/jobseeker-dashboard/mock-interview" element={<Pages.CultureCall />} />
    </Route>
    <Route element={<FeatureRoute featureKey="referral-session" redirectTo="/jobseeker-dashboard" />}>
      <Route path="/jobseeker-dashboard/referral-session" element={<Pages.ReferralSession />} />
    </Route>
    <Route path="/jobseeker-dashboard/my-sessions" element={<Pages.MySessions />} />
    <Route path="/jobseeker-dashboard/profile" element={<Pages.Profile />} />
    <Route path="/jobseeker-dashboard/jobopenings" element={<Pages.JobOpenings />} />
    <Route path="/jobseeker-dashboard/job-opening/:jobId" element={<Pages.JobDetailView />} />
    <Route path="/jobseeker-dashboard/invoices" element={<Pages.Invoices />} />
    <Route path="/jobseeker-dashboard/referral-drops" element={<Pages.WeeklyDropsPage />} />
    <Route path="/jobseeker-dashboard/my-applications" element={<Pages.ReferralTracker />} />

    <Route path="/referral-dashboard/jobseeker-dashboard" element={<Pages.JobseekerDashboard />} />
    <Route element={<FeatureRoute featureKey="resume-review" redirectTo="/referral-dashboard/jobseeker-dashboard" />}>
      <Route path="/referral-dashboard/jobseeker-dashboard/resume-review" element={<Pages.ResumeReview />} />
    </Route>
    <Route path="/referral-dashboard/jobseeker-dashboard/resume-grader" element={<Pages.ResumeGrader />} />
    <Route element={<FeatureRoute featureKey="culture-call" redirectTo="/referral-dashboard/jobseeker-dashboard" />}>
      <Route path="/referral-dashboard/jobseeker-dashboard/mock-interview" element={<Pages.CultureCall />} />
    </Route>
    <Route element={<FeatureRoute featureKey="referral-session" redirectTo="/referral-dashboard/jobseeker-dashboard" />}>
      <Route path="/referral-dashboard/jobseeker-dashboard/referral-session" element={<Pages.ReferralSession />} />
    </Route>
    <Route path="/referral-dashboard/jobseeker-dashboard/my-sessions" element={<Pages.MySessions />} />
    <Route path="/referral-dashboard/jobseeker-dashboard/jobopenings" element={<Pages.JobOpenings />} />
    <Route path="/referral-dashboard/jobseeker-dashboard/job-opening/:jobId" element={<Pages.JobDetailView />} />
    <Route path="/referral-dashboard/jobseeker-dashboard/invoices" element={<Pages.Invoices />} />
    <Route path="/referral-dashboard/jobseeker-dashboard/profile" element={<Pages.Profile />} />
    <Route path="/referral-dashboard/jobseeker-dashboard/referral-drops" element={<Pages.WeeklyDropsPage />} />
    <Route path="/referral-dashboard/jobseeker-dashboard/my-applications" element={<Pages.ReferralTracker />} />

    <Route path="/referral-dashboard/services" element={<Pages.Services />} />
    <Route path="/referral-dashboard/analytics" element={<Pages.DashbordAnalytics />} />
    <Route path="/referral-dashboard/my-sessions" element={<Pages.MySessions />} />
    <Route path="/referral-dashboard/profile" element={<Pages.Profile />} />
    <Route path="/referral-dashboard/calendar" element={<Pages.Calender />} />
    <Route path="/referral-dashboard/invoices" element={<Pages.Invoices />} />
    <Route path="/referral-dashboard/post-job" element={<Pages.PostJob />} />
    <Route path="/referral-dashboard/resume-review/:requestId" element={<Pages.ReferrerResumeReview />} />
    <Route path="/referral-dashboard/analytics/withdrawal" element={<Pages.PayoutTransfer />} />
    <Route path="/referral-dashboard/payouts" element={<Pages.Payouts />} />
    <Route path="/referral-dashboard/referral-drops" element={<Pages.ReferrerDropHubPage />} />

    {/* ── Career Trust Layer (gated by DB trust feature flags) ── */}
    <Route element={<TrustFeatureRoute flag="career_proof_layer" />}>
      <Route path="/jobseeker-dashboard/career-proof" element={<Pages.CareerProofPage />} />
      <Route path="/jobseeker-dashboard/career-proof/claim/:claimId" element={<Pages.ClaimDetailPage />} />
      <Route path="/referral-dashboard/jobseeker-dashboard/career-proof" element={<Pages.CareerProofPage />} />
      <Route path="/referral-dashboard/jobseeker-dashboard/career-proof/claim/:claimId" element={<Pages.ClaimDetailPage />} />
    </Route>
    <Route element={<TrustFeatureRoute flag="referral_passport" />}>
      <Route path="/jobseeker-dashboard/passports" element={<Pages.PassportsPage />} />
      <Route path="/referral-dashboard/jobseeker-dashboard/passports" element={<Pages.PassportsPage />} />
      {/* Recipient viewer: any signed-in user with a valid token */}
      <Route path="/passport/view" element={<Pages.PassportViewerPage />} />
    </Route>
    <Route element={<TrustFeatureRoute flag="human_verification" />}>
      <Route path="/referral-dashboard/verification-requests" element={<Pages.VerificationRequestsPage />} />
    </Route>

    <Route path="/settings/*" element={<Pages.Setting />} />
    <Route path="/support" element={<Pages.Support />} />
    <Route path="/network/:dashboardName/support" element={<Pages.Support />} />
    <Route path="/booking-confirmed/:bookingId" element={<Pages.BookingConfirmed />} />
    <Route path="/call/:sessionId" element={<Pages.DailyCall />} />
    <Route path="/rate-review/:bookingId" element={<Pages.RateReview />} />
    <Route path="/rewards" element={<Pages.Rewards />} />
    <Route path="/categories" element={<Pages.Categories />} />
    <Route path="/notifications" element={<Pages.Notifications />} />
    <Route path="/job/:jobId" element={<Pages.JobDetails />} />
    <Route path="/admin/referrer-upgrades" element={<Pages.AdminReferrerUpgrades />} />
    <Route path="/admin/user/:userCode" element={<Pages.AdminUserDetail />} />
  </Route>
);
